import { createContext, useContext, useState } from 'react';

export type RecentlyLinkedPolicyContextType = {
  recentlyLinkedPolicyNumber: string;
  setRecentlyLinkedPolicyNumber: (policyNumber: string) => void;
};

export const RecentlyLinkedPolicyContext =
  createContext<RecentlyLinkedPolicyContextType>({
    recentlyLinkedPolicyNumber: '',
    setRecentlyLinkedPolicyNumber: (policyNumber: string) => {},
  });

export const RecentlyLinkedPolicyProvider = ({
  children,
}: React.PropsWithChildren): React.ReactElement<any> => {
  const [recentlyLinkedPolicyNumber, setRecentlyLinkedPolicyNumber] =
    useState<string>('');

  return (
    <RecentlyLinkedPolicyContext.Provider
      value={{ recentlyLinkedPolicyNumber, setRecentlyLinkedPolicyNumber }}
    >
      {children}
    </RecentlyLinkedPolicyContext.Provider>
  );
};

export const useRecentlyLinkedContext = () =>
  useContext(RecentlyLinkedPolicyContext);
